import { tenant } from '@tenant';
import { default as Result } from 'antd/es/result';
import type { ReactNode } from 'react';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';

import { ErrorBoundary } from '../ErrorBoundary';

export const TABLE_LAYOUT_CONTACT_SUPPORT_TEST_ID =
  'table-layout_error-fallback_contact-support-link';

export const TableLayout = ({
  header,
  content,
  containerTestId
}: {
  header: ReactNode;
  content: ReactNode;
  containerTestId?: string;
}) => {
  return (
    <div data-testid={containerTestId}>
      <ErrorBoundary
        fallback={
          <Result
            status="warning"
            title="Oops, something went wrong!"
            extra={
              <a
                href={tenant.urls.contactUs}
                target="_blank"
                rel="noreferrer"
                data-testid={TABLE_LAYOUT_CONTACT_SUPPORT_TEST_ID}
              >
                <PrimaryButton>Contact support</PrimaryButton>
              </a>
            }
          />
        }
      >
        <div className="flex flex-row items-center justify-between p-4 pb-6">
          {header}
        </div>
        <div className="px-4">{content}</div>
      </ErrorBoundary>
    </div>
  );
};
